/** Banner above every page while the planning is locked for editing in ProjectLibre. */
import { Lock } from 'lucide-react';
import { Link } from 'react-router';
import { fmtInstant } from '../lib/format.js';
import { hasRole, useMe } from '../lib/session.js';
import styles from './AppShell.module.css';
import { usePlanningSummary } from './usePlanningSummary.js';

export function StatusBanners() {
  const me = useMe();
  const lock = usePlanningSummary()?.editLock ?? null;
  if (!lock) return null;
  return (
    <div className={styles.banner} role="status">
      <Lock aria-hidden="true" className={styles.bannerIcon} />
      <div className="grow">
        <strong>Deze planning wordt bewerkt in ProjectLibre — alleen lezen.</strong>{' '}
        <span className={styles.bannerDetail}>
          Sinds {fmtInstant(lock.at)}
          {lock.by ? ` door ${lock.by}` : ''}
          {lock.note ? ` · ${lock.note}` : ''}
        </span>
      </div>
      {hasRole(me, 'admin') && (
        <Link to="/beheer/import" className={styles.bannerAction}>
          Beheren
        </Link>
      )}
    </div>
  );
}
